'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userActivityError = exports.userActivityLoad = exports.loadUser = exports.loadUsers = exports.trackUsers = undefined;

var _errorUtil = require('../utils/errorUtil');

var _userConstants = require('./userConstants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Utils


// Constants


var trackUsers = exports.trackUsers = function trackUsers(userIds) {
    return { type: _userConstants.TRACK_USERS, userIds: userIds };
};
var loadUsers = exports.loadUsers = function loadUsers(users) {
    return { type: _userConstants.USERS_LOAD, users: users };
};
var loadUser = exports.loadUser = function loadUser(user) {
    return {
        type: _userConstants.USERS_LOAD,
        users: _defineProperty({}, user._id, user)
    };
};

var userActivityLoad = exports.userActivityLoad = function userActivityLoad(_ref) {
    var users = _ref.users,
        disconnectedUserIds = _ref.disconnectedUserIds;
    return {
        type: _userConstants.USER_ACTIVITY_LOAD,
        users: users,
        disconnectedUserIds: disconnectedUserIds
    };
};
var userActivityError = exports.userActivityError = function userActivityError(userIds, error) {
    return {
        type: _userConstants.USER_ACTIVITY_ERROR,
        userIds: userIds,
        error: (0, _errorUtil.extractErrorDetailsForAction)(error)
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/userActions.js
// module id = 758
// module chunks = 0